import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from '@/i18n';

// components
import PaperlessManualsApp from '@/components/organisms/Paperless/PaperlessManualsApp';

export default () => {
  const el = document.getElementById('js-paperless-manuals-entry');
  if (el) {
    try {
      const files = JSON.parse(el.dataset.files);
      el.removeAttribute('data-files');

      i18n.loadNamespaces(['paperless'], () => {
        const App = () => (
          <I18nextProvider i18n={i18n}>
            <Suspense fallback={<div />}>
              <PaperlessManualsApp files={files} />
            </Suspense>
          </I18nextProvider>
        );
        ReactDOM.render(<App />, el);
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('Error parsing manual files');
    }
  }
};
